import { render, staticRenderFns } from "./FormServer3Streamax.vue?vue&type=template&id=083b27cf&scoped=true&"
import script from "./FormServer3Streamax.vue?vue&type=script&lang=ts&"
export * from "./FormServer3Streamax.vue?vue&type=script&lang=ts&"
import style0 from "./FormServer3Streamax.vue?vue&type=style&index=0&id=083b27cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083b27cf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('083b27cf', component.options)
    } else {
      api.reload('083b27cf', component.options)
    }
    module.hot.accept("./FormServer3Streamax.vue?vue&type=template&id=083b27cf&scoped=true&", function () {
      api.rerender('083b27cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/ConfiguracionCamaras/Streamax/Network/ServerStreamax/FormServer3Streamax.vue"
export default component.exports